<template lang="pug">
  div
    section.header
      h2 2. Datos del consumidor
      p
        span Por favor ingrese sus datos, son obligatorios para poder hacer la reclamación
      hr

    div
      .field
        label.label Documento de identidad
        .control
          input.input(type='number', v-model="consumidor.dni", @blur="sendData")
      
      .field
        label.label Nombre
        .control
          input.input(type='text', v-model="consumidor.nombre", @blur="sendData")
      
      .field
        label.label Correo electrónico
        .control
          input.input(type='email', v-model="consumidor.email", @blur="sendData")

      .field
        label.label Domicilio
        .control
          input.input(type='text', v-model="consumidor.direccion", @blur="sendData")
      
      .field
        label.label Teléfono
        .control
          input.input(type='text', v-model="consumidor.telefono", @blur="sendData")

      .field
        label.label Nombre del padre o madre (Si es menor de edad)
        .control
          input.input(type='text', v-model="consumidor.nombrePadre", @blur="sendData")

</template>
<script>
export default {
  name: 'box-ingresar-datos-consumidor',
  data () {
    return {
      consumidor: {}
    }
  },
  created () {

  },
  methods: {
    sendData () {
      this.$emit('send', this.consumidor)
    },
    clean () {
      this.consumidor = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// Box-2-ingresar-datos-consumidor.vue?2777f480